import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { ToastMessages } from "../../components/toasts/toastMessages";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export interface DxCodeMapParams {
  order_id?: string;
}

export interface DxCodeMapResponse {
  mapping?: Record<string, string[]>;
  priority?: {
    primary_dx_code?: string;
    primary_dx_description?: string;
    matched_jcodes?: string[];
    reason?: string;
    status?: string;
  };
  jcode_vs_icd_code_map?: Record<string, string>;
}

export const getDxCodeMapNccn = async (
  params: DxCodeMapParams,
): Promise<DxCodeMapResponse> => {
  const bearerToken = await getBearerToken();

  const requestOptions: RequestInit = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearerToken}`,
    },
    body: JSON.stringify(params),
  };

  try {
    const response = await fetch(
      API_ENDPOINTS.GET_DX_CODE_MAP_NCCN,
      requestOptions,
    );

    if (!response.ok) {
      toast.error(ToastMessages.DX_CODE_MAPPING_FETCH_FAILURE);
      throw new Error(`Request failed with status ${response.status}`);
    }

    const result: DxCodeMapResponse = await response.json();
    return result;
  } catch (error) {
    console.error("Error fetching DX code map NCCN:", error);
    throw error;
  }
};
